import React from 'react';
import './bodycontent.css';
import support from '../assets/svg/support.svg';
import smartphone from '../assets/svg/smartphone.svg';



export default function Bodycontent() {
    return (
        <div>
			<div className="body-content">
				<div>
					<p className="help-text">
						In addition to submitting business easily, it also helps you:
					</p>
					<div className="help-content">
						<div className="help-wrapper">
							<p className="help-items">
								Grow your business
							</p>
							<p className="help-subitems">
								Using marketing concepts, tools, and educational resources
							</p>
						</div>
						<p className="help-items help-wrapper">Manage existing policies</p>
						<p className="help-items help-wrapper">Explore Prudential Products</p>
					</div>
				</div>
				<div>
					<p className="help-text assistance">
						Need assistance with registering for PruXpress?
					</p>
					<hr className="assistance-divider" />
					<p className="assistance contact-support">
						<img src={support} alt="Contact support" className="contact-img" />
						<span className="assistance-contact">Contact your Account Representative Team</span>
						<img src={smartphone} alt="Phone" className="contact-phone-img" />
						<span className="assistance-contact">Contact your Prudential Sales Associates</span>
					</p>
					<p className="assistance assistance-footer">They will be happy to assist you!</p>
					<p className="document-refernce-number">1003241-00002-00</p>
				</div>
			</div>
        </div>
    )
}